import { ForwardedRef, useEffect, useState, forwardRef } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'
import { AllOptional } from '@/src/@types/util'
import { Input } from '@/src/components/core/Input'

function Honeypot(
  props: AllOptional<UseFormRegisterReturn>,
  ref: ForwardedRef<any>
) {
  const [className, setClassName] = useState('')

  useEffect(() => {
    setClassName('ghqinvq')
  }, [])

  return (
    <Input
      ref={ref}
      label=""
      {...{ ...props, className }}
      autoComplete="off"
      tabIndex={-1}
    />
  )
}

export default forwardRef(Honeypot)
